import { useCallback } from 'react';
import { type Section } from '#shared/api/schema';
import { useConstructorTemplates } from '../model/slices';

export const useDenormalizedConstructorSection = () => {
    const templates = useConstructorTemplates();

    const denormalizeSection = useCallback(
        (section?: Section) => {
            if (!section?.template_id) {
                return section;
            }

            const template = templates[section.template_id];

            if (!template) {
                return section;
            }

            return {
                ...section,
                template,
            };
        },
        [templates]
    );

    return denormalizeSection;
};
